import { LabelWithRequired } from '@motili/ui';
import { CSSProperties, ReactNode } from 'react';

const FormLabel = (props: {
    label: string | ReactNode;
    required?: boolean;
    style?: CSSProperties;
    display?: 'block' | 'inline' | 'inline-block';
    dataTestId?: string;
}) => {
    const { display = 'block', label, required, style , dataTestId} = props;
    return (
        <div style={{ display }}>
            <LabelWithRequired required={required || false} style={style} dataTestId={dataTestId}>
                {label}
            </LabelWithRequired>
        </div>
    );
};

export default FormLabel;
